/**
 *  @fileOverview Time module, outputs current Perth time
 *
 *  @author       Chris Hill
 *
 */

function TimeModule (Micromodal) {
  /**
   * @description Initialises Perth time instances.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  this.init = function () {
    getPerthTime()

    setInterval(function () {
      getPerthTime()
    }, 1000)
  }

  /**
   * @description Builds Perth time element.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  let getPerthTime = function () {
    var x = new Date()
    var perthTime

    if (!toLocaleTimeStringSupportsLocales()) {
      perthTime = x.toLocaleTimeString('en-US', { timeZone: 'Australia/Perth', hour: 'numeric', minute: '2-digit' })
    } else {
      var now = new Date()
      var nowUtc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds())
      var utc = Date.parse(nowUtc)
      perthTime = new Date(utc + 28800000).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
    }

    if (perthTime !== undefined) {
      var perth = document.getElementsByClassName('perthTime')
      for (var i = 0; i < perth.length; i++) {
        perth[i].innerHTML = perthTime.replace(/\s/g, '').toLowerCase()
      }
    }
  }

  /**
   * @description Checks to see if timezones can be used.
   *
   * @example
   * //
   * @returns {boolean} Result of test.
   */
  let toLocaleTimeStringSupportsLocales = function () {
    try {
      new Date().toLocaleTimeString('en-US', { timeZone: 'Australia/Perth', hour: 'numeric', minute: '2-digit' })
    } catch (e) {
      return e.name === 'RangeError'
    }
    return false
  }
}

module.exports = TimeModule
